import { graphql } from 'react-relay';
import type {
	useMigratedRecentlyMigratedRecentlyQuery as useMigratedRecentlyMigratedRecentlyQuery$data,
	useMigratedRecentlyMigratedRecentlyQueryVariables as useMigratedRecentlyMigratedRecentlyQuery$variables,
} from './__types__/useMigratedRecentlyMigratedRecentlyQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useMigratedRecently = (contentId: string) => {
	const { data, loading, error } = useQueryInterop<
		useMigratedRecentlyMigratedRecentlyQuery$data,
		useMigratedRecentlyMigratedRecentlyQuery$variables
	>(
		graphql`
			query useMigratedRecentlyMigratedRecentlyQuery($contentId: ID!) {
				content(id: $contentId) {
					nodes {
						id
						metadata {
							frontend {
								migratedRecently
							}
						}
					}
				}
			}
		`,
		{
			variables: { contentId },
		},
	);

	if (loading || error) {
		return false;
	}

	return data?.content?.nodes?.[0]?.metadata?.frontend?.migratedRecently || false;
};
